module.exports = __webpack_public_path__ + "img/clock.31d03789.svg";